import { render, staticRenderFns } from "./israGudSet.vue?vue&type=template&id=49b04dc4&scoped=true&"
import script from "./israGudSet.vue?vue&type=script&lang=js&"
export * from "./israGudSet.vue?vue&type=script&lang=js&"
import style0 from "./israGudSet.vue?vue&type=style&index=0&id=49b04dc4&prod&scoped=true&lang=css&"
import style1 from "./israGudSet.vue?vue&type=style&index=1&id=49b04dc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b04dc4",
  null
  
)

export default component.exports